module.exports = __webpack_public_path__ + "static/media/underline.c4f18445.svg";